import { ConnectedTradeWay } from 'components/secondaryMarket/shared/SidePanel/TradeWay.connect';
import { PendingPanelFooter, PendingPanelHeader } from 'components/secondaryMarket/shared/status/Panel';

import { FlexColumnPanel } from '../../../shared/SidePanel/FlexColumnPanel';

type QuotingSidePanelProps = Readonly<{
  tabId: string;
  className?: string;
}>;

export function QuotingSidePanel({ tabId }: QuotingSidePanelProps) {
  return (
    <FlexColumnPanel>
      <PendingPanelHeader>
        <ConnectedTradeWay formId={tabId} />
      </PendingPanelHeader>
      <div className="progress-bar progress-bar-animated bg-dark w-100" style={{ height: 1 }}></div>
      <PendingPanelFooter statusKey="secondaryMarket.sidePanel.label.quoteInProgress" />
    </FlexColumnPanel>
  );
}
QuotingSidePanel.displayName = 'QuotingSidePanel';
